import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import Myorders from "../components/Myorders";
import { useSelector, useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Modal from "./../components/Modal";
import useOrderDetailbyNumber from "../Hooks/useOrderDetailbyNumber";
import ReCAPTCHA from "react-google-recaptcha";


const OrderTracking = () =>{
    const isAuthenticated = useSelector((state) => state.auth.user);
    const [captchaToken, setCaptchaToken] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const dispatch = useDispatch();
    const { fetchOrder, orderByEmail, loading, error } = useOrderDetailbyNumber();
    const [selectedOrder, setSelectedOrder] = useState(null)
    const handleCaptchaChange = (token) => {
      setCaptchaToken(token);
    };
    const closeModal = () => {
        setIsModalOpen(false);
      };
    const [formData, setFormData] = useState({
        orderNumber: "",
        email: "",
      });
    
      const [errors, setErrors] = useState({
        email: "",
      });
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    
        // Email validation
        if (name === "email") {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          setErrors({
            ...errors,
            email: emailRegex.test(value) ? "" : "Invalid email address",
          });
        }
      };
      const handleSubmit = async (e) => {
        e.preventDefault();
        if (!captchaToken) {
          toast.error("Please complete the captcha verification.");
          return;
        }
        if (!errors.email && formData.orderNumber && formData.email) {
        const dt = await fetchOrder(formData.orderNumber, formData.email)
        setSelectedOrder(dt)
         setIsModalOpen(true)
        } else {
            toast.errors("Please correct the errors before submitting.");
        }
      };
return (
  <>
  <div className="mx-auto md:px-8 w-full min-h-full header"> My Orders </div>
  <div className="space-y-4 body">
 
 {isAuthenticated ? (
     <Myorders />
 ) : (
    <div>
        <Modal isOpen={isModalOpen} closeModal={closeModal} heading="Order Details" data={orderByEmail} dataMode="orderdetails"  />
        <form onSubmit={handleSubmit} className="max-w-md mx-auto p-6 bg-gray-100 rounded-md shadow-md space-y-4">
          {/* <h2 className="text-2xl font-bold text-center">Order Credentials</h2> */}
    
          {/* Order Number */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Order Number</label>
            <input
              type="text"
              name="orderNumber"
              value={formData.orderNumber}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              required
            />
          </div>
    
          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className={`w-full border rounded-md p-2 focus:ring-2 focus:outline-none ${
                errors.email ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
              }`}
              required
            />
            {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
          </div>

          {process.env.REACT_APP_RECAPTCHA_ENABLER === "true" ? (
          <div className="mb-4">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={handleCaptchaChange}
            />
          </div>
          ):null}
    
          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
          >
            Submit
          </button>
        </form>
    </div>
    
 )}  
         
  
   </div>
  </>
       
    );

}
export default OrderTracking;